import classNames from 'classnames'
import { Button } from '~/components/Button'
import { SectionContainer } from '~/components/SectionContainer'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './ButtonCta.module.css'
import { ButtonCtaProps } from './ButtonCta.types'

export const ButtonCta = ({
  style,
  text,
  colour,
  textColour,
  width = 'medium',
  size = 'md',
  link,
  openInNewTab,
  alignment,
}: ButtonCtaProps) => {
  const handleRedirect = () => {
    if (openInNewTab) {
      window.open(link, '_blank')
    } else {
      window.location.href = link
    }
  }

  return (
    <SectionContainer width={width}>
      <div
        className={classNames(styles.wrapper, 'flex', {
          'justify-center': alignment === 'centered',
          'justify-start': alignment === 'left-with-padding',
          'justify-end': alignment === 'right-with-padding',
        })}>
        <Button
          onClick={() => {
            return handleRedirect()
          }}
          style={{
            backgroundColor: colour,
          }}
          status={style}
          size={size}>
          <Typography
            tag={TypographyTag.span}
            style={{
              color: textColour,
            }}
            variant={TypographyVariant.BodyRegular}>
            {text}
          </Typography>
        </Button>
      </div>
    </SectionContainer>
  )
}
